/**
 * Shared hit test bridge between MarkerCanvas (sets the function)
 * and SimpleSelectMode (calls it).
 */

export type MarkerHitTestFn = (x: number, y: number) => string | undefined;

let _hitTest: MarkerHitTestFn | null = null;

export function setMarkerCanvasHitTest(fn: MarkerHitTestFn | null) {
	_hitTest = fn;
}

export function markerCanvasHitTest(x: number, y: number): string | undefined {
	return _hitTest?.(x, y);
}
